import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    optionalBoolean,
    requiredString,
    SYNC_UPDATE_VALIDATION_SCHEMA,
    timestamp,
} from './common';

export const createOnboardingAddSchema = () =>
    z
        .object({
            id: requiredString,
            overlay_archived_invoices: optionalBoolean,
            overlay_rsvp_one: optionalBoolean,
            overlay_rsvp_two: optionalBoolean,
            overlay_rsvp_three: optionalBoolean,
            overlay_rsvp_four: optionalBoolean,
            getting_started_section_dismissed: optionalBoolean,
            are_procedures_onboarded: optionalBoolean,
            are_entries_onboarded: optionalBoolean,
            are_invoices_onboarded: optionalBoolean,
            are_business_details_onboarded: optionalBoolean,
            user_id: requiredString,
            created_at: timestamp,
            updated_at: timestamp,
        })
        .strict();

export const createOnboardingUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createOnboardingAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.onboardings,
    );

export const createOnboardingDeleteSchema = () => createDeleteSchema();

export const createOnboardingSchemas = () => ({
    add: createOnboardingAddSchema(),
    update: createOnboardingUpdateSchema(),
    delete: createOnboardingDeleteSchema(),
});

export const onboardingRawRecordSchema = createOnboardingAddSchema();
